<section>
  <app-form-header [menuDefinition]="menuDefinition" (onCancel)="cancel()" [cancelText]="'COMMON.OPEN_RENTAL_OBJECT'">
    <ng-template>
      @if (isAdvertismentLoaded) {
        @if (!dataContext?.approvedAt && !dataContext?.sentToPlatformAt) {
          <li style="display: inline-flex">
            <button type="button" class="btn btn-outlined additional-button" (click)="onSubmit()" [disabled]="isSaving">
              {{ 'LETTING.ADVERTISMENT.SAVE_DRAFT' | translate }}
            </button>
          </li>
          <li style="display: inline-flex">
            <button type="button" class="btn btn-primary additional-button" (click)="saveAndSubmit()" [disabled]="isSaving">
              <img src="assets/icons/save.svg" alt="save" />{{ 'LETTING.ADVERTISMENT.PUBLISH' | translate }}
            </button>
          </li>
        } @else {
          @if (canUnpublishFromBoplatsSverige) {
            <li style="display: inline-flex">
              <button
                type="button"
                class="btn btn-outlined additional-button"
                (click)="unpublishFromBoplatsSverige()"
                [disabled]="isSaving || isUnpublishingFromBoplatsSverige"
              >
                {{ 'LETTING.ADVERTISMENT.UNPUBLISH' | translate }}
              </button>
            </li>
          }
          <p class="timestamp">
            {{ platformTimestampLabel | translate }} {{ platformTimestamp | date: 'medium' : '' : currentLang }}
          </p>
        }
      }
    </ng-template>
  </app-form-header>
  @if (form) {
    <form class="astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      @if (dataContext.isNew && dataContext.rentalObjectId) {
        <letting-unpublished-warning
          [rentalObjectId]="dataContext.rentalObjectId"
        ></letting-unpublished-warning>
      }

      <section class="astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-select [control]="form.controls.platform" [itemsSource]="platformSelection"></astral-select>
        @if (form.controls.approvedAt) {
            <astral-date-picker [control]="form.controls.approvedAt"></astral-date-picker>
        }
          <astral-input [span]="2" [control]="form.controls.rentalObjectName"></astral-input>
        </astral-layout-group>
      </section>

      @if (homeqSelected && homeqOptions) {
        <letting-advertisment-homeq
          [letting]="dataContext"
          [homeqOptions]="homeqOptions"
          [officeName]="homeQOfficeName"
          [readonly]="dataContext.approvedAt || dataContext.sentToPlatformAt"
          #homeqform
        ></letting-advertisment-homeq>
        <letting-document-control
          [parentId]="dataContext.rentalObjectId"
          [control]="form.controls.rentalObjectDocuments"
          [documents]="dataContext.rentalObjectDocuments"
          [type]="RentalObjectDocumentType.InteriorPhoto"
          [mimeTypes]="imageMimes"
          maxFiles="20"
        ></letting-document-control>
        <letting-document-control
          [parentId]="dataContext.rentalObjectId"
          [control]="form.controls.floorPlanDocuments"
          [documents]="dataContext.floorPlanDocuments"
          [type]="RentalObjectDocumentType.FloorPlan"
          [mimeTypes]="pdfOrImageMimes"
          maxFiles="1"
        ></letting-document-control>
        <letting-document-control
          [isBuilding]="true"
          [parentId]="dataContext.buildingId"
          [control]="form.controls.buildingFacadePhotos"
          [documents]="dataContext.buildingFacadePhotos"
          [type]="BuildingDocumentType.ExteriorPhoto"
          [mimeTypes]="imageMimes"
          maxFiles="10"
        ></letting-document-control>
        <letting-document-control
          [isBuilding]="true"
          [parentId]="dataContext.buildingId"
          [control]="form.controls.buildingCommonAreasPhotos"
          [documents]="dataContext.buildingCommonAreasPhotos"
          [type]="BuildingDocumentType.CommonAreasPhoto"
          [mimeTypes]="imageMimes"
          maxFiles="10"
        ></letting-document-control>
        <letting-document-control
          [isBuilding]="true"
          [parentId]="dataContext.buildingId"
          [control]="form.controls.buildingSurroundingsPhotos"
          [documents]="dataContext.buildingSurroundingsPhotos"
          [type]="BuildingDocumentType.ExteriorPhoto"
          [mimeTypes]="imageMimes"
          maxFiles="10"
        ></letting-document-control>
        <letting-document-control
          [isBuilding]="true"
          [parentId]="dataContext.buildingId"
          [control]="form.controls.buildingSalesDocuments"
          [documents]="dataContext.buildingSalesDocuments"
          [type]="BuildingDocumentType.SalesDocument"
          [mimeTypes]="pdfMimes"
          maxFiles="5"
        ></letting-document-control>
      }

      @if (boplatsSverigeSelected) {
        <letting-advertisment-boplats-sverige
          [letting]="dataContext"
          [readonly]="dataContext.approvedAt || dataContext.sentToPlatformAt"
          #boplatsSverigeForm
        ></letting-advertisment-boplats-sverige>
        <letting-document-control
          [parentId]="dataContext.rentalObjectId"
          [control]="form.controls.rentalObjectDocuments"
          [documents]="dataContext.rentalObjectDocuments"
          [type]="RentalObjectDocumentType.InteriorPhoto"
          [mimeTypes]="imageMimes"
          maxFiles="20"
        ></letting-document-control>
        <letting-document-control
          [isBuilding]="true"
          [parentId]="dataContext.buildingId"
          [control]="form.controls.buildingSurroundingsPhotos"
          [documents]="dataContext.buildingSurroundingsPhotos"
          [type]="BuildingDocumentType.ExteriorPhoto"
          [mimeTypes]="imageMimes"
          maxFiles="10"
        ></letting-document-control>
        <letting-document-control
          [parentId]="dataContext.rentalObjectId"
          [control]="form.controls.floorPlanDocuments"
          [documents]="dataContext.floorPlanDocuments"
          [type]="RentalObjectDocumentType.FloorPlan"
          [mimeTypes]="pdfOrImageMimes"
          maxFiles="1"
        ></letting-document-control>
      }

      @if (dhMarketSelected && dhMarketOptions) {
        <letting-advertisment-market
          [letting]="dataContext"
          [tenants]="tenants"
          [marketOptions]="dhMarketOptions"
          [allowBoplatsSverigePublish]="canPublishDhMarketToBoplatsSverige"
          [readonly]="dataContext.approvedAt || dataContext.sentToPlatformAt"
          #marketform
        ></letting-advertisment-market>
        <letting-advertisment-market-area
          [control]="form.controls.dhMarketArea"
          [letting]="dataContext"
          [marketOptions]="dhMarketOptions"
          #marketareaform
        ></letting-advertisment-market-area>
        <letting-document-control
          [parentId]="dataContext.rentalObjectId"
          [control]="form.controls.rentalObjectPhotos"
          [documents]="dataContext.rentalObjectDocuments"
          [type]="RentalObjectDocumentType.InteriorPhoto"
          [mimeTypes]="imageMimes"
          maxFiles="20"
        ></letting-document-control>
        <letting-document-control
          [parentId]="dataContext.rentalObjectId"
          [control]="form.controls.floorPlanDocuments"
          [documents]="dataContext.floorPlanDocuments"
          [type]="RentalObjectDocumentType.FloorPlan"
          [mimeTypes]="pdfOrImageMimes"
          maxFiles="1"
        ></letting-document-control>
        @if (!form.controls.dhMarketArea.value) {
          <letting-document-control
            [isBuilding]="true"
            [parentId]="dataContext.buildingId"
            [control]="form.controls.buildingSurroundingsPhotos"
            [documents]="dataContext.buildingSurroundingsPhotos"
            [type]="BuildingDocumentType.ExteriorPhoto"
            [mimeTypes]="imageMimes"
            maxFiles="10"
          ></letting-document-control>
        }
      }
    </form>
  }
</section>
